import React, { Component } from 'react';
import {
  WatchlistBaseModel,
  WatchlistIndividualRecord,
  WatchlistListsModel,
  WatchlistNameModel,
  WatchlistNameType,
} from '../../../domain/watchlist/WatchlistDomains';
import { FormicaProps, withFormica } from '../../../helpers/withFormica';
import { RootState, store } from '../../../redux/store';
import { changeWatchlist } from '../../../redux/actions/WatchlistActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import WatchlistService from '../../../service/WatchlistService';
import ServiceContainer from '../../../config/ServiceContainer';
import { ServiceNames } from '../../../constant/ServiceNames';
import CustomLoading from '../../custom/CustomLoading';
import Breadcrumb from '../../Breadcrumb';
import { initialPagePath } from '../../../redux/reducers/PageReducer';
import ComponentName from '../../../constant/ComponentName';
import FolderService from '../../../service/FolderService';
import moment from 'moment';
import CustomTabv2 from '../../custom/CustomTabv2';
import _ from 'lodash';
import WatchlistInformationComponent from '../watchlist/WatchlistInformationComponent';
import WatchlistNewsComponent from '../watchlist/WatchlistNewsComponent';
import { ConfirmPopup } from 'primereact/confirmpopup';
import LanguageUtil from '../../../util/LanguageUtil';

class WatchlistRelationDetailComponent extends Component<Props, State> {
  public state: State = new State();
  private watchlistService: WatchlistService = ServiceContainer.getInstance().get(ServiceNames.WATCHLIST);

  render() {
    const { selectedResponse, date } = this.state;

    if (selectedResponse == undefined) {
      return <CustomLoading />;
    }
    return (
      <div className='w-full h-full flex flex-col'>
        <Breadcrumb />
        <ConfirmPopup />
        <div className={'p-5'}>
          <div className={'flex justify-between'}>
            <div className={'flex'}>
              <span
                key={'icon'}
                className='w-[60px] h-[60px] min-h-[60px] min-w-[60px] 2xl:w-[80px] 2xl:h-[80px] 2xl:min-h-[80px] 2xl:min-w-[80px] flex justify-center items-center rounded-[50%] bg-[#EFF2FE] mr-1'
              >
                {this.getImage()}
              </span>
              <div className={'flex flex-col justify-center pl-3'}>
                <span className={'text-[24px] 2xl:text-4xl font-normal'}>{this.getName()}</span>
                <div className={'flex items-center gap-x-2'}>
                  {this.getCategory()?.map((value: string, index: number) => {
                    return (
                      <span
                        key={index}
                        className={`flex min-w-[60px] text-xs shrink-0 2xl:text-md h-full justify-center px-[8px] py-[3px] items-center rounded-[50px] bg-[#F6F6F9] text-[#4F4F4F]`}
                      >
                        {value}
                      </span>
                    );
                  })}
                  <span
                    className={`flex min-w-[60px] text-xs shrink-0 2xl:text-md h-full justify-center items-center px-[8px] py-[3px] rounded-[50px] bg-[#F6F6F9] text-[#4F4F4F]`}
                  >
                    {date}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={'flex w-full h-full'}>
          <CustomTabv2 tab={this.getTabs()} />
        </div>
      </div>
    );
  }

  public async componentDidMount() {
    this.setState({ date: moment().format('DD/MM/yyyy HH:mm').valueOf() });
    await this.isPagePathNotInitialized();
    await this.getLists();
    await this.getWatchlist();
  }

  private isPagePathNotInitialized = async () => {
    const { router } = this.props;
    const page = store.getState().page;
    const initial = initialPagePath[ComponentName.WATCHLIST];
    if (page.pagePath.length == 0 || page.pagePath[0].title != initial?.title) {
      await FolderService.calculate('WITHOUT_FOLDER', ComponentName.WATCHLIST, router.location.pathname, store.getState().page);
    }
  };

  private getLists = async () => {
    try {
      const lists: WatchlistListsModel[] | undefined = await this.watchlistService.getLists();
      this.setState({ watchlistResponse: lists || [] });
    } catch (e) {
      console.error(e);
    }
  };

  private getWatchlist = async () => {
    const { relationId, listId } = this.calculateUrl();
    try {
      if (relationId == null && listId == null) return;
      const recordResponse = await this.watchlistService.getIndividualId(listId!, relationId!);
      if (recordResponse.error || recordResponse.data == undefined) {
        return;
      }
      const response: WatchlistBaseModel = {
        score: 100,
        record: recordResponse.data.data,
      };
      this.setState({ selectedResponse: response });
    } catch (e) {
      console.error(e);
    }
  };

  private calculateUrl = () => {
    const {
      router: { params },
    } = this.props;
    const previousSearchParams = new URLSearchParams(params.id);
    return {
      listId: previousSearchParams.get('listId'),
      relationId: previousSearchParams.get('relationId'),
    };
  };

  private getName = (): string => {
    const { selectedResponse } = this.state;
    if (selectedResponse === undefined) return 'Name Undefined';
    const flattenedArray: any[] = selectedResponse?.record?.records?.map((value) => {
      return value?.watchlistRecord?.names.map((name) => {
        return {
          ...name,
          watchlistId: value.watchlistId,
          source: value.watchlistRecord.source,
        };
      });
    });
    const namesData: WatchlistNameModel[] = [].concat(...flattenedArray);
    if (namesData === undefined || namesData.length === 0) return 'Name Undefined';
    const longestPrimaryData: WatchlistNameModel[] = namesData.filter((item: WatchlistNameModel) => item.nameType === WatchlistNameType.PRIMARY);
    if (longestPrimaryData.length === 0) return namesData[0].value;
    const data: WatchlistNameModel = longestPrimaryData.reduce((a, b) => (a.value.length > b.value.length ? a : b));
    return data.value;
  };

  private getCategory = () => {
    const { selectedResponse } = this.state;
    if (selectedResponse == undefined) return;
    const categories: any[] = [];
    selectedResponse?.record?.records?.forEach((response) => {
      categories.push(response.watchlistRecord.categories);
    });
    return _.uniqBy([].concat(...categories));
  };

  private getImage = () => {
    const { selectedResponse } = this.state;
    if (selectedResponse) {
      const images = selectedResponse?.record?.records?.filter(
        (record) => (record.watchlistRecord as WatchlistIndividualRecord).images && (record.watchlistRecord as WatchlistIndividualRecord).images.length > 0,
      );
      if (images != undefined && images.length > 0) {
        return (
          <img
            src={(images[0].watchlistRecord as WatchlistIndividualRecord).images[0]}
            alt='-'
            onClick={() => window.open((images[0].watchlistRecord as WatchlistIndividualRecord).images[0], '_blank')}
            className={
              'w-[60px] h-[60px] cursor-pointer min-h-[60px] min-w-[60px] 2xl:w-[80px] 2xl:h-[80px] 2xl:min-h-[80px] 2xl:min-w-[80px] flex justify-center items-center rounded-[50%] bg-[#EFF2FE] object-cover'
            }
          />
        );
      } else {
        return <img src={'/icons/individual.svg'} alt='individual' />;
      }
    }
  };

  protected getTabs = () => {
    const { selectedResponse, watchlistResponse } = this.state;
    return [
      {
        key: 'Information',
        label: LanguageUtil.get({ id: 'common.button.information', defaultMessage: 'Information' }),
        content: (
          <WatchlistInformationComponent selectedResponse={selectedResponse?.record?.records || []} watchlistResponse={watchlistResponse} type={'Individual'} />
        ),
      },
      {
        key: 'News',
        label: LanguageUtil.get({ id: 'common.button.news', defaultMessage: 'News' }),
        content: <WatchlistNewsComponent />,
      },
    ];
  };
}

interface Props extends FormicaProps, ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  watchlist: state.watchlist,
});
const mapDispatchToProps = { changeWatchlist };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

class State {
  selectedResponse: WatchlistBaseModel | undefined;
  date: string | undefined;
  watchlistResponse: WatchlistListsModel[] = [];
}

export default withFormica(connector(WatchlistRelationDetailComponent));
